import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
var Button = function (_a) {
    var className = _a.className, type = _a.type, disabled = _a.disabled, ghost = _a.ghost, onClick = _a.onClick, children = _a.children;
    var _b = useMemo(function () {
        var colorClass = '_sz-text-[#8c8c8c]';
        var bgClass = '_sz-bg-white';
        var shadowClass = '';
        var afterBorderClass = 'after:_sz-content-[""] after:_sz-border-[0.5px] after:_sz-border-black/[.12] after:_sz-border-solid';
        if (type === 'theme') {
            colorClass = '_sz-text-white';
            bgClass = '_sz-bg-[var(--sunzi-theme-color)]';
            shadowClass = '_sz-shadow-[0_1px_3px_rgba(0,0,0,0.12)]';
        }
        if (disabled) {
            colorClass = '_sz-text-black/[.12]';
            bgClass = '_sz-bg-black/[.12]';
            shadowClass = '_sz-shadow-none';
        }
        if (ghost) {
            colorClass = '_sz-text-[var(--sunzi-theme-color)]';
            bgClass = '_sz-bg-transparent';
            shadowClass = '_sz-shadow-none';
            afterBorderClass =
                'after:_sz-content-[""] after:_sz-border after:_sz-border-solid';
        }
        return {
            color: colorClass,
            bgColor: bgClass,
            shadow: shadowClass,
            afterBorder: afterBorderClass
        };
    }, [type, ghost, disabled]), color = _b.color, bgColor = _b.bgColor, shadow = _b.shadow, afterBorder = _b.afterBorder;
    return (_jsx("div", { className: "_sz-relative _sz-flex  _sz-min-h-[44px] _sz-cursor-pointer _sz-select-none _sz-items-center _sz-justify-center _sz-overflow-hidden _sz-rounded-md _sz-px-3.5 _sz-py-2.5 _sz-capitalize after:_sz-absolute after:_sz-inset-0 after:_sz-rounded-md ".concat(type === 'theme' ? '_sz-font-bold _sz-uppercase' : '', " ").concat(disabled ? '_sz-pointer-events-none _sz-border-none ' : '', "  ").concat(color, " ").concat(bgColor, " ").concat(shadow, " ").concat(afterBorder, " ").concat(className, " "), onClick: onClick, children: children }));
};
export default Button;
